<template>
  <div class="social_side_bar" :class="{ 'show': showBar && !isClosed }">
    <a class="line" :href="lineHref" target="_blank" data-placement="top" :title="tooltipText">
      <span class="num">ID：{{lineId}}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-line" viewBox="0 0 16 16">
        <title>Line</title>
        <path d="M8 0c4.411 0 8 2.912 8 6.492 0 1.433-.555 2.723-1.715 3.994-1.678 1.932-5.431 4.285-6.285 4.645-.83.35-.734-.197-.696-.413l.003-.018.114-.685c.027-.204.055-.521-.026-.723-.09-.223-.444-.339-.704-.395C2.846 12.39 0 9.701 0 6.492 0 2.912 3.59 0 8 0ZM5.022 7.686H3.497V4.918a.156.156 0 0 0-.155-.156H2.78a.156.156 0 0 0-.156.156v3.486c0 .041.017.08.044.107v.001l.002.002.002.002a.154.154 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157Zm.791-2.924a.156.156 0 0 0-.156.156v3.486c0 .086.07.155.156.155h.562c.086 0 .155-.07.155-.155V4.918a.156.156 0 0 0-.155-.156h-.562Zm3.863 0a.156.156 0 0 0-.156.156v2.07L7.923 4.832a.17.17 0 0 0-.013-.015v-.001a.139.139 0 0 0-.01-.01l-.003-.003a.092.092 0 0 0-.011-.009h-.001L7.88 4.79l-.003-.002a.029.029 0 0 0-.005-.003l-.008-.005h-.002l-.003-.002-.01-.004-.004-.002a.093.093 0 0 0-.01-.003h-.002l-.003-.001-.009-.002h-.006l-.003-.001h-.004l-.002-.001h-.574a.156.156 0 0 0-.156.155v3.486c0 .086.07.155.156.155h.56c.087 0 .157-.07.157-.155v-2.07l1.6 2.16a.154.154 0 0 0 .039.038l.001.001.01.006.004.002a.066.066 0 0 0 .008.004l.007.003.005.002a.168.168 0 0 0 .01.003h.003a.155.155 0 0 0 .04.006h.56c.087 0 .157-.07.157-.155V4.918a.156.156 0 0 0-.156-.156h-.561Zm3.815.717v-.56a.156.156 0 0 0-.155-.157h-2.242a.155.155 0 0 0-.108.044h-.001l-.001.002-.002.003a.155.155 0 0 0-.044.107v3.486c0 .041.017.08.044.107l.002.003.002.002a.155.155 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156Z"></path>
      </svg>
    </a>
<!--    <button @click="closeBar" class="close-button">×</button>-->
  </div>
</template>

<script>
export default {
  name: 'SocialSideBar',
  props: {
    lineId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showBar: true,
      tooltipText: '加入官方line帳號',
      lastScrollPosition: 0,
      scrollTimeout: null, // 用於存儲定時器
      isClosed: true,
      scrollHide: false
    };
  },
  computed: {
    lineHref() {
      return `https://line.me/R/ti/p/@${this.lineId}`;
      // return `https://social-plugins.line.me/widget/popup/friend?lineId=${this.lineId}&lang=zh_Hant`;
    }
  },
  mounted() {
    // $('[data-toggle="tooltip"]').tooltip();
    if(this.lineId.length > 0){
      this.isClosed = false;
    }
    if(this.scrollHide){
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  },
  methods: {
    handleScroll() {
      const currentScrollPosition = window.scrollY;
      const deltaY = currentScrollPosition - this.lastScrollPosition;

      // 取消之前的定時器
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      if (Math.abs(deltaY) > 30) { // 設定滾動幅度閾值為50
        this.showBar = false;
      }

      // 設置新的定時器，在滾動停止後500ms執行
      this.scrollTimeout = setTimeout(() => {
        this.showBar = true;
      }, 200);

      this.lastScrollPosition = currentScrollPosition;
    },
    closeBar() {
      this.isClosed = true; // 設置 isClosed 為 true，隱藏側邊欄
    }
  }
};
</script>
<style scoped lang="scss">

.social_side_bar {
  position: fixed;
  bottom: 53px;
  right: 0;
  color: white;
  padding: 10px;
  text-align: center;
  z-index: 9999;
  border: 0;
  transition: opacity 0.2s ease; /* 新增過渡效果 */
  opacity: 0;
  &.show {
    opacity: 1;
  }

  .line {
    background: linear-gradient(145deg, #00c300, #06c755);
    width: 50px;
    height: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 2.25rem;
    padding-right: 0.5rem;
    color: #ffffff;
    text-align: right;
    line-height: 50px;
    transition: width 0.3s ease, padding-left 0.3s ease, background 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3), 0 6px 20px rgba(0, 0, 0, 0.25); /* 加上陰影使其更立體 */
    .num {
      white-space: nowrap;
      opacity: 0;
      transition: opacity 0.2s ease;
      font-size: 14px;
      position: absolute;
      left: 30px;
      top: 50%;
      transform: translateY(-50%);
    }

    svg {
      width: 38px;
      height: 38px;
      filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));
    }

    &:hover {
      width: 210px;
      background: linear-gradient(145deg, #06c755, #00c300);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3), 0 12px 40px rgba(0, 0, 0, 0.25); /* 增加 hover 狀態的陰影 */

      .num {
        opacity: 1;
      }
    }
  }
  .close-button {
    background: none;
    border: none;
    color: white;
    font-size: 16px;
    cursor: pointer;
    margin-top: 5px;
  }
}
</style>
